import type { ComponentProps } from 'react'
import type { AuthProvider } from 'react-oidc-context'

import { useConfig } from '@/modules/config/useConfig'

import { AUTH_CALLBACK_PATH } from './constants'
import { clearRecoveryFlag } from './oidcRecovery'

export const useAuthProps = ():
  | ComponentProps<typeof AuthProvider>
  | undefined => {
  const { auth } = useConfig()
  const { enableAuth, authority, clientId } = auth

  if (!enableAuth) return undefined

  if (!clientId) throw new Error('Auth is enabled but clientId is not set')

  return {
    authority,
    client_id: clientId,
    redirect_uri: window.location.origin + AUTH_CALLBACK_PATH,
    scope: 'openid profile email permissions',
    response_type: 'code',
    onSigninCallback: () => {
      // Strips query params from the URL after successful authentication
      // This prevents stale query params from causing auth errors if accessed with browser back button
      window.history.replaceState({}, '', window.location.pathname)
      clearRecoveryFlag()
    },
    // if 'code' AND 'state' query params are present on any page, auth will run through the signin callback flow,
    // which we want to avoid on page load for any route other than the callback route
    skipSigninCallback: window.location.pathname !== AUTH_CALLBACK_PATH,
  }
}
